module.exports = __webpack_public_path__ + "img/coins.af3af2e0.png";